import { createContext } from 'react';

import type { ApolloError } from '@reckon-web/gql-api-client';

import type {
  ReckonOneUIPreferences,
  UpdateReckonOneUIPreferencesFields,
} from './ReckonOneUIPreferencesOperations';

export type ReckonOneUIPreferencesContextValue = {
  /** `undefined` until the first response arrives — consumers apply their
   * own default rather than the provider blocking render on it. */
  preferences: ReckonOneUIPreferences | undefined;
  loading: boolean;
  error?: ApolloError;
  updatePreferences: (
    fields: UpdateReckonOneUIPreferencesFields
  ) => Promise<void>;
};

export const ReckonOneUIPreferencesContext = createContext<ReckonOneUIPreferencesContextValue | null>(
  null
);
